/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuloaderror2Inputs */

const en_menuloaderror2 = /** @type {(inputs: Menuloaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The menus could not be loaded.`)
};

const de_menuloaderror2 = /** @type {(inputs: Menuloaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Menüs konnten nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "The menus could not be loaded." |
*
* @param {Menuloaderror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuloaderror2 = /** @type {((inputs?: Menuloaderror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuloaderror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuloaderror2(inputs)
	return de_menuloaderror2(inputs)
});
export { menuloaderror2 as "menuLoadError" }